module.exports = __webpack_public_path__ + "assets/img/service-module2-9.aad979ac.png";